var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"syn-button-size",attrs:{"src":"images/synergismUI/reality.png"},on:{"click":_vm.handleClick}})}
var staticRenderFns = []

export { render, staticRenderFns }